module.exports = __webpack_public_path__ + "static/img/jf.0b0d3849.png";